import { render, staticRenderFns } from "./LayoutGroupMember.vue?vue&type=template&id=6ab72d3a&"
import script from "./LayoutGroupMember.vue?vue&type=script&lang=ts&"
export * from "./LayoutGroupMember.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports